module.exports = __webpack_public_path__ + "static/media/indexacapital--main.350dfb95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/indexacapital/indexacapital--main.jpg
// module id = 181
// module chunks = 0